import { render, staticRenderFns } from "./YzNeedDraft.vue?vue&type=template&id=04b2bcc2&scoped=true"
import script from "./YzNeedDraft.vue?vue&type=script&lang=js"
export * from "./YzNeedDraft.vue?vue&type=script&lang=js"
import style0 from "./YzNeedDraft.vue?vue&type=style&index=0&id=04b2bcc2&prod&lang=css"
import style1 from "./YzNeedDraft.vue?vue&type=style&index=1&id=04b2bcc2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b2bcc2",
  null
  
)

export default component.exports